export default {
  showMenu: true,
  showHeader: true,
  showFooter: true,
  menuOpen: false,
  menuFolded: false
}



// WEBPACK FOOTER //
// ./src/app/_default/store/state.js